import { render, staticRenderFns } from "./EditUserBookingSelectComponent.vue?vue&type=template&id=22764dfa"
import script from "./EditUserBookingSelectComponent.vue?vue&type=script&lang=js"
export * from "./EditUserBookingSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports